function primeiroNome(nome: string) {
  return nome.trim().split(/\s+/).filter(Boolean)[0]?.toLowerCase() ?? "";
}

export function validarEmailUsuarioEquipe(email: string) {
  const emailNormalizado = email.trim().toLowerCase();
  const partes = emailNormalizado.split("@");

  if (partes.length !== 2 || !partes[0] || !partes[1]) {
    return "Informe um e-mail valido.";
  }

  const dominio = partes[1];
  if (dominio.startsWith("gm") && dominio !== "gmail.com") {
    return "Se o dominio comecar com gm, ele precisa terminar como gmail.com.";
  }

  return null;
}

export function somenteDigitosTelefone(telefone: string) {
  return telefone.replace(/\D/g, "");
}

export function validarTelefoneUsuarioEquipe(telefone: string) {
  const telefoneLimpo = telefone.trim();

  if (!telefoneLimpo) {
    return "Informe o telefone.";
  }

  if (!/^\d+$/.test(telefoneLimpo)) {
    return "O telefone deve conter apenas numeros.";
  }

  if (telefoneLimpo.length < 10 || telefoneLimpo.length > 11) {
    return "O telefone deve ter entre 10 e 11 numeros.";
  }

  return null;
}

export function validarSenhaUsuarioEquipe(senha: string, nome: string) {
  const senhaLimpa = senha.trim();

  if (!senhaLimpa) {
    return "Informe a senha.";
  }

  if (senhaLimpa.length < 11 || senhaLimpa.length > 128) {
    return "A senha precisa ter entre 11 e 128 caracteres.";
  }

  if (!/[A-Z]/.test(senhaLimpa)) {
    return "A senha precisa ter pelo menos uma letra maiuscula.";
  }

  if (!/[^A-Za-z0-9]/.test(senhaLimpa)) {
    return "A senha precisa ter pelo menos um simbolo.";
  }

  const nomeBase = primeiroNome(nome);
  if (nomeBase && senhaLimpa.toLowerCase().includes(nomeBase)) {
    return "A senha nao pode conter o primeiro nome do usuario.";
  }

  return null;
}
